// All Wix acquisition apps share billing behavior, using their own identity.
export function wixUpgradeUrl(status) {
  const product = status?.wix_product;
  if (product) {
    const target = status.upgrade_url || product.upgrade_url;
    if (target && new URL(target).origin === 'https://www.wix.com') return target;
    if (!product.app_id || !status.instance_id) throw new Error('Missing Wix app billing identity');
  }
  const appId = product ? product.app_id : process.env.REACT_APP_WIX_APP_ID;
  return `https://www.wix.com/apps/upgrade/${encodeURIComponent(appId)}?appInstanceId=${encodeURIComponent(status.instance_id)}`;
}
